module.exports = __webpack_public_path__ + "img/media-4.10d91039.png";